import { render, staticRenderFns } from "./shopDetail.vue?vue&type=template&id=06c1c81b&scoped=true"
import script from "./shopDetail.vue?vue&type=script&lang=ts"
export * from "./shopDetail.vue?vue&type=script&lang=ts"
import style0 from "./shopDetail.vue?vue&type=style&index=0&id=06c1c81b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c1c81b",
  null
  
)

export default component.exports